export default __webpack_public_path__ + "static/media/BankPlaceholder.9b5cea89.png";